import React from 'react';
import './ScenarioIndices.css';
import PixelIcon from './PixelIcon';

function ScenarioIndices({ indices }) {
  const { raceIndex, slowdownIndex, status, confidence } = indices;
  
  // Indices are on the 0-3 scale
  const getBarWidth = (value) => `${Math.min(100, Math.max(0, (value / 3) * 100)).toFixed(0)}%`;
  const badgeClass = { RACE_DOMINANT: 'race', SLOWDOWN_DOMINANT: 'slowdown', BALANCED: 'balanced' }[status] || 'balanced';
  
  return (
    <div className="scenario-indices">
      <div className="section-title glow-text">
        <span className="title-icon"><PixelIcon name="bars" size={18} /></span>
        SCENARIO INDICES
      </div>
      
      <div className="indices-grid">
        {/* Race Index */}
        <div className="index-card pixel-border-thin">
          <div className="index-header">
            <h3 className="text-red">RACE INDEX</h3>
            <div className="index-value text-red">{raceIndex.toFixed(2)}</div>
          </div>
          <div className="index-description">
            Uncontrolled acceleration scenario
          </div>
          <div className="index-bar" aria-hidden="true">
            <div 
              className="index-bar-fill race-fill"
              style={{ width: getBarWidth(raceIndex) }}
            >
            </div>
          </div>
          <div className="index-indicators">
            <span className="indicator">Military Integration</span>
            <span className="indicator">Centralization</span>
            <span className="indicator">Economic Dependency</span>
          </div>
        </div>
        
        {/* Slowdown Index */}
        <div className="index-card pixel-border-thin">
          <div className="index-header">
            <h3 className="text-green">SLOWDOWN INDEX</h3>
            <div className="index-value text-green">{slowdownIndex.toFixed(2)}</div>
          </div>
          <div className="index-description">
            Controlled development scenario
          </div>
          <div className="index-bar" aria-hidden="true">
            <div 
              className="index-bar-fill slowdown-fill"
              style={{ width: getBarWidth(slowdownIndex) }}
            >
            </div>
          </div>
          <div className="index-indicators">
            <span className="indicator">Model Governance</span>
            <span className="indicator">Compute Control</span>
            <span className="indicator">International Cooperation</span>
            <span className="indicator">Critical Narrative</span>
          </div>
        </div>
        
        {/* Status Card */}
        <div className="status-card pixel-border-thin">
          <div className="status-header">
            <h3 className="text-cyan">CURRENT STATUS</h3>
          </div>
          <div className="status-content">
            <div className="status-main">
              <div className={`status-badge ${badgeClass}`}>
                {status.replace('_', ' ')}
              </div>
              <div className="status-confidence">
                <span className="text-secondary">Confidence:</span>
                <span className="text-cyan"> {(confidence * 100).toFixed(0)}%</span>
              </div>
            </div>
            <div className="status-chart">
              <div className="status-comparison">
                <div className="comparison-bar">
                  <div 
                    className="comparison-race"
                    style={{ width: `${(raceIndex / (raceIndex + slowdownIndex) * 100).toFixed(0)}%` }}
                  ></div>
                  <div 
                    className="comparison-slowdown"
                    style={{ width: `${(slowdownIndex / (raceIndex + slowdownIndex) * 100).toFixed(0)}%` }}
                  ></div>
                </div>
                <div className="comparison-labels">
                  <span className="text-red">Race</span>
                  <span className="text-green">Slowdown</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScenarioIndices;
